// https://gist.github.com/lwkchan/2dfe69061ff4f4cc6606f48f36c07e6d

import { useState } from 'react';
import Cookies from 'universal-cookie';

const useCookie = key => {
  const cookies = new Cookies();
  const [item, setItemValue] = useState(() => {
    const cookie = cookies.get(key);

    if (cookie) {
      return cookie;
    }
    return null;
  });

  const setValue = (value, options) => {
    setItemValue(value);
    cookies.set(key, value, options);
  };

  const removeItem = () => {
    cookies.remove(key);
  };

  return [item, setValue, removeItem];
};

export default useCookie;
